import React from 'react';

function SearchBox() {
    return (
        <div>
            <div className='search-field margin-t-8px margin-r-8px'>
                <form noValidate>
                    <i className='fa fa-search margin-l-4px'></i>
                    <label className='sr-only'>
                        Search for a Campaign
                    </label>
                    <input
                        id='pv-search-box'
                        type='text'
                        placeholder='You can search for'
                    />
                </form>
            </div>
        </div>
    );
}

export default SearchBox;
